import { Carousel, Card, Stack, Button } from "react-bootstrap";

import StockChart, { MainChart } from "./ProductGraph";

import './tw.css';

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3,
        slidesToSlide: 3 // optional, default to 1.
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
        slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    }
};


const data = {
    stockFullName: "SW Limited.",
    stockShortName: "ASX:SFW",
    price: {
      current: 2.32,
      open: 2.23,
      low: 2.215,
      high: 2.325,
      cap: 93765011,
      ratio: 20.1,
      dividend: 1.67,
    },
    chartData: {
      labels: [
        "10:00",
        "",
        "",
        "",
        "12:00",
        "",
        "",
        "",
        "2:00",
        "",
        "",
        "",
        "4:00",
      ],
      data: [
        2.23,
        2.215,
        2.22,
        2.25,
        2.245,
        2.27,
        2.28,
        2.29,
        2.3,
        2.29,
        2.325,
        2.325,
        2.32,
      ],
    },
  };

const ProductBanner=({reviews})=>{
    return (
   


<Carousel style={{ height: 300 }}>
  {reviews.map((review, index) => (
    <Carousel.Item style={{ height: 300 }}>
      <Stack
        direction="horizontal"
        className="h-100 justify-content-center align-items-center"
        gap={3}
      >
 <div className="relative min-w-screen    flex items-center justify-center px-40 py-5 bg-gray-50 ">
<div className="bg-white shadow-lg rounded m-12 p-8 flex md:bg-orange flex min-w-screen ring-1 ring-gray-900/5 sm:mx-auto sm:max-w-lg sm:rounded-lg sm:px-10">
          <div className="w-1/3 hidden sm:block">  
            <img 
            className="rounded-full md:border-white md:border-solid md:border-4" src="https://randomuser.me/api/portraits/men/44.jpg"/>
         
  
          </div>
          <div className="sm:w-2/3 ">
   
            <h3 className="text-black text-xl font-semibold md:text-white">Ruben Garza</h3>  
                    
            <p className="text-black font-thin text-sm leading-normal md:text-white">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis eaque, exercitationem praesentium nihil.
            </p>
          </div>  
      </div>

      <div className="bg-white shadow-lg rounded m-8 p-8 flex md:bg-orange flex md:inline-flex  min-w-screen">
          <div className="w-1/3 hidden sm:block">  
            <img 
            className="rounded-full md:border-white md:border-solid md:border-4" src="https://randomuser.me/api/portraits/men/44.jpg"/>
         
  
          </div>
          <div className="w-2/3 px-2">
   
            <h3 className="text-black text-xl font-semibold md:text-white">Ruben Garza</h3>  
                    
            <p className="text-black font-thin text-sm leading-normal md:text-white">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis eaque, exercitationem praesentium nihil.
            </p>
          </div>  
      </div>


<div className="bg-white shadow-lg rounded m-8 p-8 flex md:bg-orange flex md:inline-flex min-w-screen">
          <div className="w-1/3 hidden sm:block">  
            <img 
            className="rounded-full md:border-white md:border-solid md:border-4" src="https://randomuser.me/api/portraits/men/44.jpg"/>
         
  
          </div>
          <div className="sm:w-2/3 ">
   
            <h3 className="text-black text-xl font-semibold md:text-white">Ruben Garza</h3>  
                    
            <p className="text-black font-thin text-sm leading-normal md:text-white">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis eaque, exercitationem praesentium nihil.
            </p>
          </div>  
      </div>

      </div>
{/* 
       <div class="py-8 px-8 max-w-sm mx-auto bg-white rounded-xl shadow-lg space-y-2 sm:py-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-6">
<img class="block mx-auto w-24 h-24 rounded-full sm:mx-0 sm:shrink-0" src="https://earthsky.org/upl/2014/06/Apache_head_in_rocks_Ebihens_France.jpg" alt="Woman's Face"/>
<div class="text-center space-y-2 sm:text-left">
<div class="space-y-0.5">
<p class="text-lg text-black font-semibold">
Erin Lindford
</p>
<p class="text-slate-500 font-medium">
Product Engineer
</p>
</div>
<button class="px-4 py-1 text-sm text-purple-600 font-semibold rounded-full border border-purple-200 hover:text-white hover:bg-purple-600 hover:border-transparent focus:outline-none focus:ring-2 focus:ring-purple-600 focus:ring-offset-2">Message</button>
</div>
</div> */}


</Stack>
    </Carousel.Item>
  ))}
</Carousel>



    );
}

  
export const TrendingProducts = () => {
    const reviews = [
        { _id: 1, text: "abc" },
        { _id: 2, text: "def" },
        { _id: 3, text: "ghi" },
        { _id: 4, text: "jkl" },
        { _id: 5, text: "mno" },
        { _id: 6, text: "pqr" },
        { _id: 7, text: "stu" },
        { _id: 8, text: "vwx" },
        { _id: 9, text: "yza" }
      ];
    
      return (
        <div style={{paddingTop:"50px"}}>
          <h1 className="text-center fw-bold my-5" >
            Trending Products
          </h1>
          <div className="rounded shadow-xl overflow-hidden w-full md:flex">

          <div className="flex w-full md:w-1/2 px-5 pb-4 pt-8  items-center bg-gray-50">
          <MainChart info={data}/>

                </div>

                <div className="flex w-full md:w-1/2 px-5 pb-4 pt-8  items-center bg-gray-50">
          <MainChart info={data}/>

                </div>

                </div>


<ProductBanner reviews={reviews}/>

<div className=" mx-auto bg-gray-200 rounded-xl shadow border p-8 m-10" >



<div class="relative flex min-h-screen flex-col justify-center overflow-hidden bg-gray-50 py-6 sm:py-12">
  <img src="img/beams.jpg" alt="" class="absolute top-1/2 left-1/2 max-w-none -translate-x-1/2 -translate-y-1/2" width="1308" />
  <div class="absolute inset-0 bg-[url(img/grid.svg)] bg-center [mask-image:linear-gradient(180deg,white,rgba(255,255,255,0))]"></div>

  <div className="flex md:inline-flex min-w-screen">
  <div className="w-2/4">  

  <div className="relative min-w-screen    flex items-center justify-center px-5 py-1">
      <StockChart info={data} />
    </div>
    <div className="relative min-w-screen    flex items-center justify-center px-5 py-1">
      <StockChart info={data} />
    </div>
    <div className="relative min-w-screen    flex items-center justify-center px-5 py-1">
      <StockChart info={data} />
    </div>
</div>
<div className="w-2/4  ">  
  <div class="relative bg-white px-6 pt-10 pb-8 shadow-xl ring-1 ring-gray-900/5 sm:mx-auto sm:max-w-lg sm:rounded-lg sm:px-10">
    <div class="mx-auto max-w-md">
      <img src="/img/logo.svg" class="h-6" alt="Tailwind Play" />
      <div class="divide-y divide-gray-300/50">
        <div class="space-y-6 py-8 text-base leading-7 text-gray-600">
          <p>An advanced online playground for Tailwind CSS, including support for things like:</p>
          <ul class="space-y-4">
            <li class="flex items-center">
              <svg class="h-6 w-6 flex-none fill-sky-100 stroke-sky-500 stroke-2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="11" />
                <path d="m8 13 2.165 2.165a1 1 0 0 0 1.521-.126L16 9" fill="none" />
              </svg>
              <p class="ml-4">
                Customizing your
                <code class="text-sm font-bold text-gray-900">tailwind.config.js</code> file
              </p>
            </li>
            <li class="flex items-center">
              <svg class="h-6 w-6 flex-none fill-sky-100 stroke-sky-500 stroke-2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="11" />
                <path d="m8 13 2.165 2.165a1 1 0 0 0 1.521-.126L16 9" fill="none" />
              </svg>
              <p class="ml-4">
                Extracting classes with
                <code class="text-sm font-bold text-gray-900">@apply</code>
              </p>
            </li>
            <li class="flex items-center">
              <svg class="h-6 w-6 flex-none fill-sky-100 stroke-sky-500 stroke-2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="11" />
                <path d="m8 13 2.165 2.165a1 1 0 0 0 1.521-.126L16 9" fill="none" />
              </svg>
              <p class="ml-4">Code completion with instant preview</p>
            </li>
          </ul>
          <p>Perfect for learning how the framework works, prototyping a new idea, or creating a demo to share online.</p>
        </div>
        <div class="pt-8 text-base font-semibold leading-7">
          <p class="text-gray-900">Want to dig deeper into Tailwind?</p>
          <p>
            <a href="https://tailwindcss.com/docs" class="text-sky-500 hover:text-sky-600">Read the docs &rarr;</a>
          </p>
        </div>
      </div>
    </div>
  </div>

</div>

</div>


</div>
                    
     
     
           </div>
        </div>
      );
}
